export default function loadVideo() {
    const container = document.querySelector('.js-video-container');
    const poster = document.querySelector('.js-video-poster');

    if (container && poster) {
        poster.addEventListener('click', () => {
            container.innerHTML = `
              <video
                width="700"
                height="394"
                controls
                autoplay
                playsinline
            >
                <source
                    src="/img/website-images/features/video/learn-by-doing.mp4"
                    type="video/mp4"
                >
                Your browser doesn't support the video
            </video>
            `;
        });
    }
}
